<template>
  <div>
    <b-form-group>
      <label :for="id">{{ label }}</label>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
        :vid="vid"
      >
        <vue-editor
          :id="id"
          v-model.number="innerValue"
          :placeholder="placeholder"
          :disabled="readonly"
          autocomplete="off"
          :maxlength="maxlength"
          :editor-toolbar="customToolbar"
          @input="onInput"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { VueEditor } from 'vue2-editor'
import { sweetAlert } from '@core/mixins/sweetAlert'

export default {
  name: 'InputNumberField',
  components: {
    BFormGroup,
    ValidationProvider,
    VueEditor,
  },
  mixins: [sweetAlert],
  props: {
    label: {
      type: String,
      required: true,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    maxlength: {
      type: String,
      required: false,
      default: '',
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    value: {
      type: null,
      default: '',
    },
    onInput: {
      type: Function,
      default: null,
      required: false,
    },
    vid: {
      type: String,
      default: 'input-number',
    },
  },
  data() {
    return {
      innerValue: '',
      customToolbar: [
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['code-block'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
      ],
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
